import * as API from './index'

export default {
    get: params => {
        return API.GET('/api/TeamMatch/Get', params)
    },
    getList: params => {
        return API.GET('/api/TeamMatch/List', params)
    },
    register: params => {
        return API.POST('/api/TeamMatch/register', params)
    },
    edit: params => {
        return API.POST('/api/TeamMatch/Edit', params)
    },
    enableAll: params => {
        return API.POSTFMT('/api/TeamMatch/enableAll', params)
    },
    disableAll: params => {
        return API.POSTFMT('/api/TeamMatch/disableAll', params)
    },
    enablePart: params => {
        return API.POSTFMT('/api/TeamMatch/enablePart', params)
    },
    disablePart: params => {
        return API.POSTFMT('/api/TeamMatch/disablePart', params)
    },
    delete: params => {
        return API.DELETE('/api/TeamMatch/delete', params)
    },
    deleteBatch: params => {
        return API.DELETEBATCH('/api/TeamMatch/DeleteBatch', params)
    }, summary: params => {
        return API.GET('/api/TeamMatch/summary', params)
    },
    changeSequence: params => {
        return API.POST('/api/TeamMatch/ChangeSequence', params)
    }, select: params => {
        return API.GET('/api/TeamMatch/Select', params)
    },
    getAllTeams: params => {
        return API.GET('/api/TeamMatch/GetAllTeams', params)
    },
    download: params => {
        return API.GETBlog('/api/TeamMatch/Export', params)
    },
    addAdmin: params => {
        return API.POST('/api/TeamMatch/addAdmin', params)
    },
    editAdmin: params => {
        return API.POST('/api/TeamMatch/editAdmin', params)
    }
}


// WEBPACK FOOTER //
// ./src/apis/teamMatch.js